import React from 'react';

import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { isEmptyObject } from 'helpers/formatObject';
import { DeleteOutlineRounded } from '@mui/icons-material';
import { NewDialog, NewDialogTitle, NewDialogContent, NewDialogActions } from 'components';
import { Stack, Avatar, Button, Typography, IconButton, CircularProgress, Tooltip } from '@mui/material';

export default function NewDeletePopup({ ids, title, refetch, selection, selectable, handleSelectable, graph }) {
  const [open, setOpen] = React.useState(false);
  const { userToken } = useSelector((state) => state.auth);

  const onOpen = () => {
    if (!selectable) {
      handleSelectable();
      return toast.info(<FormattedMessage id="selectItems" />);
    }
    if (selection) {
      return setOpen(true);
    }
    return toast.warning(<FormattedMessage id="selectItems" />);
  };

  const onClose = () => {
    setOpen(false);
    handleSelectable();
  };

  const [handleDelete, { loading }] = useMutation(graph.delete.query, {
    context: {
      serviceName: graph.delete.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onDelete = async () => {
    try {
      const { data, errors } = await handleDelete({
        variables: { ids },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.delete.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {}
  };

  return (
    <>
      <Tooltip title={<FormattedMessage id="delete" />}>
        <IconButton size="medium" color="error" onClick={onOpen} sx={{ bgcolor: 'action.hover' }}>
          {loading ? (
            <CircularProgress color="error" size={25} />
          ) : (
            <DeleteOutlineRounded color="error" fontSize="small" />
          )}
        </IconButton>
      </Tooltip>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title="حذف" onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack flex={1} rowGap={2} alignItems="center" justifyContent="center" bgcolor="background.paper">
            <Avatar
              variant="rounded"
              sx={{
                width: 120,
                height: 120,
                borderRadius: 4,
                bgcolor: 'action.hover',
              }}
              src="/assets/icons/glass/trash.svg"
            />
            <Typography variant="subtitle1">آیا از حذف این موارد مطمئن هستید؟</Typography>
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button color="warning" variant="outlined" onClick={onClose}>
            <FormattedMessage id="ignore" />
          </Button>
          <Button
            autoFocus
            color="error"
            variant="contained"
            disabled={loading}
            onClick={onDelete}
            sx={{ minWidth: 80 }}
          >
            {loading ? <CircularProgress color="inherit" size={24} /> : <FormattedMessage id="ok" />}
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
